import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel } from '../../../../toolkit/uicomponent';
import * as React from 'react';
import { Strings } from '../../../../../utils/resources/strings';
import { ButtonComponent } from '../../../../toolkit/button/buttoncomponent';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import { CreateAccountOTPMessageComponentProps, CreateAccountOTPMessageComponentHandler, CreateAccountOTPMessageComponentState } from './createaccountotpmessagecomponent';
import { CreateAccountOTPMessageCSSStyle } from './createaccountotpmessagecss';
import { MessageComponent } from '../../../../toolkit/messagecomponent/messagecomponent';
import { ConfirmationComponent } from '../../confirmation/confirmationcomponent';
import { FloatingTextComponent } from '../../../../toolkit/floatingtext/floatingtextcomponent';
import { OTPCheckDto, OTPCheckDtoImpl } from '../../../../../core/dto/otp/otpcheck/otpcheckdto';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../../popup/loaderwrappercomponent';

import "./create-account-otp-style.css";

export class CreateAccountOTPMessageViewImpl extends UIComponentViewImpl<UIDataModel>
{
    numberComponent: any;
    popUpComponent: PopUpWrapperComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;


    bindHandlers()
    {
        this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
        this.onResendClick = this.onResendClick.bind(this);
        this.onSubmitButtonClick = this.onSubmitButtonClick.bind(this);
        this.onLoginClick = this.onLoginClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
    }
    
    draw(props: CreateAccountOTPMessageComponentProps, state: CreateAccountOTPMessageComponentState, cssStyle: CreateAccountOTPMessageCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        console.log(state.isResendButtonRestricted);

        if(state.isCreateAccountSuccess)
        {
            return <ConfirmationComponent context={props.context} message={props.context.getResources().getString(Strings.account_created)} onClick={this.onLoginClick}/>;
        }
        else
        {
        return (
            <div id="create-account-otp-wrapper" style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getInnerWrapperCSSStyle()}>
                {/* <img onClick={this.onLogoClicked} style={{cursor: "pointer",width:'100%',height:"80px",marginBottom:'45px',marginTop:'0px',marginLeft:'-135px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  /> */}
                <img id="create-account-otp-logo" onClick={this.onLogoClicked} style={{cursor: "pointer", width:'auto', marginBottom:'45px',marginTop:'0px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                <label id="create-account-otp-heading" style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.enterotp)}</label>
                   
                  { state.isOTPMessageShow &&
                  <div id="create-account-otp-page-message-wrapper" style={cssStyle.getMessageCSSStyle()}>
                       <MessageComponent onCloseButtonClicked={this.onCloseButtonClick} messageContent={props.context.getResources().getString(Strings.otp_message)}  context={props.context} />
                   </div>
                  }

                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                        <FloatingTextComponent hint={this.getContext().getResources().getString(Strings.otphint)} maxLength={this.getUIProps().context.getResources().getString(Strings.otp_max_length)} ref={(item: any) => this.numberComponent = item} id={"#otp"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.enterotp)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.incorrectotp)}/>
                    </div>
                    
                    <div style={cssStyle.getRequestOTPButtonCSSStyle()}>
                        <ButtonComponent onClick={this.onSubmitButtonClick}style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)}  context={props.context} label={props.context.getResources().getString(Strings.verify)}/>
                    </div>
        
                    <br/>
                    <div style={cssStyle.getSignUpRowDivCSSStyle()}>
                        <label style={cssStyle.getDoUHaveAccountCSSStyle()}>{props.context.getResources().getString(Strings.didntreceivecode)}</label>
                        <label onClick={this.onResendClick} style={cssStyle.getResendButtonCSSStyle(state.isResendButtonRestricted)}>{props.context.getResources().getString(Strings.resendotp)}</label>
                        <div id="countdown"style={{display:'flex',fontSize:'14px'}}/>
                                           
                    </div>
                </div>
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
                <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            </div>
        );
                }
    }

    validate(): boolean
    {
        if(this.numberComponent.validate())
        {
            let numberLength = +this.getUIProps().context.getResources().getString(Strings.otp_max_length);

            if(this.numberComponent.getData().length !== numberLength)
            {
                this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.incorrectotp));
                
            }
            // else if(this.getContext().getUserContext().getMsisdn() === this.numberComponent.getData())
            // {
            //     this.numberComponent.setErrorMessage("Number cannot be same as logged in number.");
            // }
            
            else{
            return true;
            }
        }
        return false;
    }  
    
    getData():OTPCheckDto
    {
        let request = new OTPCheckDtoImpl();
        request.setOtp(this.numberComponent.getData());
        return request;
    }
    protected onLogoClicked()
    {
        (this.getUIComponentHandler() as CreateAccountOTPMessageComponentHandler).onLogoClicked();
    }
    onCloseButtonClick():void
    {
        (this.getUIComponentHandler() as CreateAccountOTPMessageComponentHandler).onCloseButtonClicked();
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    showPopup(id:string,msg:string,type:AlertType):void
    {
      
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

    }
    onSubmitButtonClick():void
    {
        (this.getUIComponentHandler() as CreateAccountOTPMessageComponentHandler).onSubmitButtonClick();
    }

    onResendClick():void
    {
        (this.getUIComponentHandler() as CreateAccountOTPMessageComponentHandler).onResendOtpClick();    
    }

    onLoginClick():void
    {
        (this.getUIComponentHandler() as CreateAccountOTPMessageComponentHandler).onLoginButtonClick();    
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountotp/createaccountotpmessagecomponent/createaccountotpmessageview.tsx